import { Layout, Section } from 'layout';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { InvoiceScansListScreen } from './screens/invoice-scans-list-screen';
import { InvoiceScanDetailScreen } from './screens/invoice-scan-detail-screen';

const InvoiceScanningPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={InvoiceScansListScreen} />
          <Route path={`${match.url}/view/:id`} component={InvoiceScanDetailScreen} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default InvoiceScanningPage;
